export var Modals;

(function (Modals) {
  Modals["Info"] = "Info";
  Modals["Confirm"] = "Confirm";
  Modals["Error"] = "Error";
})(Modals || (Modals = {}));